import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import Config from '../../../Config';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers.js';
import { gaEvent } from '../../../utilities/analytics/tracking';

const Advantages = (props) => {

    return (
        <>
            <div>
                <div className='advantages-title' id={props.iContent.idToScroll?.value}>{props.iContent.title?.value}</div>
                <div className='advantages-items'>
                    {props.iContent.advantagesList.expandedValue?.map((item, index) => (
                        <div className='advantages-item' key={index}>
                            <div className='advantages-item-icon'>
                                <Image src={Config.epiBaseUrl + item.iconImage.value?.url} />
                            </div>
                            <div className='advantages-item-title'>{item.title?.value}</div>
                            <div className='advantages-item-sub-title'>{item.subTitle?.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};
export default Advantages;
